export default __webpack_public_path__ + "locales/ko-KR/InviteDialog.json?hash=f188c08161f22998a5ea080f07f471a1";